import { render, staticRenderFns } from "./mpuser.vue?vue&type=template&id=6c023b15&"
import script from "./mpuser.vue?vue&type=script&lang=js&"
export * from "./mpuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports